export enum Langs {
  Fr = 'fr',
}
